import { ImageURLUitls } from "@akc/foundation";
import React from "react";
import styles from "./ActivityPromotion.module.less";

interface Props {
    promotionImageList: string[];
}

const ActivityPromotion: React.FC<Props> = ({ promotionImageList }) => {

    return (
        <div className={styles.ActivityPromotion}>
            <h3 className={styles.list__title}>活动介绍</h3>
            <div className={styles.list__body}>
                {promotionImageList?.map((item, index) => (
                    <img
                        key={index}
                        src={ImageURLUitls.normalProcessImage(item, 375)}
                        style={{
                            verticalAlign: "middle",
                            width: "100%",
                            height: "auto",
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default ActivityPromotion;
